import Immutable from 'immutable';

const Content: {
  name: string,
  count: number
} = {
  name: '',
  count: 0
};

class GroupAndCount extends Immutable.Record(Content) {
  static fromJS (json: object): GroupAndCount {
    return new GroupAndCount(json);
  }
}

export default GroupAndCount;
